module.exports = __webpack_public_path__ + "media/promo/promo/images/logo-72f8938f3538727bdcd1cc07563c8ea2.png";